/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_Seats_Free_Until_RenewalInputs */



/**
* | output |
* | --- |
* | "A free seat that isn't a base seat – for example the one someone left when they moved to another type – stays paid until your next renewal, and is dropped th..." |
*
* @param {Members_Seats_Free_Until_RenewalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_seats_free_until_renewal = /** @type {((inputs?: Members_Seats_Free_Until_RenewalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Seats_Free_Until_RenewalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein freier Platz, der kein Basisplatz ist – zum Beispiel der Platz, den jemand beim Wechsel zu einem anderen Typ verlassen hat –, bleibt bis zu Ihrer nächsten Verlängerung bezahlt und entfällt dann, wenn er noch frei ist.")
	return /** @type {LocalizedString} */ ("A free seat that isn't a base seat – for example the one someone left when they moved to another type – stays paid until your next renewal, and is dropped then if it's still empty.")
});